import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DocsSidebar from "./components/DocsSidebar";
import DocsHeader from "./components/DocsHeader";

function Docs() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const sections = [
        {
            title: t("docs.sections.introduction"),
            items: [{ title: t("docs.sections.principles"), path: "/docs" }],
        },
        // {
        //     title: "Platform",
        //     items: [
        //         { title: "Introduction", path: "/docs/platform" },
        //         { title: "Automation", path: "/docs/automation" },
        //         { title: "Use Cases", path: "/docs/use-cases" },
        //     ],
        // },
        {
            title: t("docs.sections.skills"),
            items: [
                {
                    title: t("docs.sections.usingSkills"),
                    path: "/docs/skills/",
                },
                {
                    title: t("docs.sections.wordDocumentVariables"),
                    path: "/docs/skills/word-variables",
                },
                {
                    title: t("docs.sections.chatGPTSkill"),
                    path: "/docs/skills/chatgpt-skill",
                },
                {
                    title: t("docs.links.databases"),
                    path: "/docs/skills/databases/",
                },
            ],
        },
        // {
        //     title: "Developer Docs",
        //     items: [
        //         { title: "Introduction", path: "/docs/developer" },
        //         {
        //             title: "Node SDK",
        //             path: "/docs/developer/node-sdk",
        //         },
        //         {
        //             title: "API Reference",
        //             path: "/docs/developer/api-reference",
        //         },
        //         {
        //             title: "Express.js Example",
        //             path: "/docs/developer/express",
        //         },

        //         // {
        //         //     title: "Deployment options",
        //         //     path: "/docs/deployment-options",
        //         // },
        //     ],
        // },
        // {
        //     title: "Guides",
        //     items: [
        //         { title: "Models", path: "/docs/models" },
        //         { title: "Pricing", path: "/docs/pricing" },
        //         {
        //             title: "Prompting strategies",
        //             path: "/docs/prompting-strategies",
        //         },
        //         { title: "Language support", path: "/docs/language-support" },
        //         {
        //             title: "Account management",
        //             path: "/docs/account-management",
        //         },
        //     ],
        // },
        // {
        //     title: "Best practices",
        //     items: [
        //         { title: "Prompt security", path: "/docs/prompt-security" },
        //         { title: "Transparency", path: "/docs/transparency" },
        //         { title: "Mitigating bias", path: "/docs/mitigating-bias" },
        //         { title: "Research papers", path: "/docs/research-papers" },
        //     ],
        // },
    ];

    const links = [
        {
            title: t("docs.links.home"),
            path: "/docs",
        },
        {
            title: t("docs.links.backToApp"),
            path: "/",
        },

        // {
        //     title: "Platform",
        //     path: "/docs/platform",
        // },
        // {
        //     title: "Skills",
        //     path: "/docs/skills/word-variables",
        // },
        // {
        //     title: "Developer",
        //     path: "/docs/developer",
        // },
    ];

    return (
        <div className="min-h-screen bg-gray-50 ">
            <DocsHeader
                onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
                links={links}
            />
            <div className="flex">
                <DocsSidebar
                    isOpen={isSidebarOpen}
                    sections={sections}
                    onClose={() => setIsSidebarOpen(false)}
                />
                <main className="flex-1 px-4 sm:px-6 lg:px-8 overflow-x-hidden">
                    <div className="max-w-[90rem] mx-auto">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Docs;
